export const PERIODS_TYPE = {
  ATTENDANCE: 'attendance',
}
